import { Button } from 'src/components';
import EmailConfirmationWrapper from 'src/components/Wrapper/EmailConfirmationWrapper';

type CheckEmailData = {
  isCheckedEmail: boolean;
  email: string;
};

type CheckEmailProps = CheckEmailData & {
  updateFields: (fields: Partial<CheckEmailData>) => void;
  nextStep: () => void;
};

const CheckYourEmail = ({ nextStep, updateFields, email }: CheckEmailProps) => {
  return (
    <EmailConfirmationWrapper>
      <h1 className="text-blue-950 text-[22px] font-bold ">
        Check Your Email!
      </h1>
      <div className="w-[432px] text-center">
        <p className="text-blue-950 text-sm font-medium font-SFProDisplay leading-5">
          We have sent a confirmation code to{' '}
          <span className="text-lightBlue">{email}</span>
          <br />
          Please confirm your email address.
        </p>
      </div>
      <Button
        variant="normal"
        size="sm"
        label="Continue"
        className="block w-[436px] mt-10"
        type="submit"
        onClick={() => {
          updateFields({ isCheckedEmail: true });
          nextStep();
        }}
      />
    </EmailConfirmationWrapper>
  );
};

export default CheckYourEmail;
